var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / here"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 115",
    d: "M7.73051 18.2422C4.67677 18.9354 3.7832 19.9595 3.7832 21.4435C3.7832 23.6578 8.35731 25.4528 13.9998 25.4528C19.6422 25.4528 24.2163 23.6578 24.2163 21.4435C24.2163 19.9595 23.0905 19.2026 20.0368 18.5094",
    stroke: "#F9F9F9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 893_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 114 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9985 6.83132C13.301 6.83132 12.7356 7.39671 12.7356 8.09417C12.7356 8.79162 13.301 9.35702 13.9985 9.35702C14.6959 9.35702 15.2613 8.79162 15.2613 8.09417C15.2613 7.39671 14.6959 6.83132 13.9985 6.83132ZM11.5195 8.09417C11.5195 6.72509 12.6294 5.61523 13.9985 5.61523C15.3675 5.61523 16.4774 6.72509 16.4774 8.09417C16.4774 9.46325 15.3675 10.5731 13.9985 10.5731C12.6294 10.5731 11.5195 9.46325 11.5195 8.09417Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 2.76296C16.9443 2.76296 19.3314 5.15019 19.3314 8.09501C19.3314 9.12989 18.9852 10.3173 18.3895 11.5704C17.799 12.8125 16.9997 14.0437 16.1806 15.1453C15.7805 15.6833 15.3798 16.185 15.0026 16.6359L15.7958 17.5821C17.7938 15.2214 20.5474 11.3733 20.5474 8.09501C20.5474 4.4786 17.6159 1.54688 13.9993 1.54688C10.3827 1.54688 7.45117 4.4786 7.45117 8.09501C7.45117 12.0824 11.2438 16.9126 12.9504 18.8843C13.4458 19.4566 13.7654 19.7881 13.7654 19.7881C13.7654 19.7881 14.0967 19.4683 14.6127 18.9145C13.7042 17.8956 13.8219 18.0336 13.7042 17.8956C13.131 17.2232 12.3683 16.2768 11.6082 15.1787C10.0404 12.9142 8.66725 10.2623 8.66725 8.09501C8.66725 5.15019 11.0543 2.76296 13.9993 2.76296Z",
    fill: "#F9F9F9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.5e3e52883bb96b4c3e26b7f04b4cc49a.svg";
export { ForwardRef as ReactComponent };